<div class="personalProfileSelectorScreen">
  <div class="profileSelectorProfileType">
    {{ pageData.title }}
  </div>
  <div
    (click)="onClick(pageData.title, pageData.firstName)"
    [ngClass]="{ active: active }"
    class="personalProfileSelectorScreen__content--text"
  >
    <div
      [tabIndex]="0"
      [attr.aria-label]="this.active ? pageData.displayName + ' Selected' : ''"
      role="button"
      class="displayName"
    >
      {{ pageData.displayName }}
    </div>
    <span [ngClass]="{ active: active }" class="personal-check-mark"></span>
  </div>
</div>
